import { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function HomePage() {
  const bottomRef = useRef(null);
  const navigate = useNavigate();

  const adresseInputRef = useRef(null);
  const [adresseDepart, setAdresseDepart] = useState("");
  const [adresseDepartPlaceOk, setAdresseDepartPlaceOk] = useState(false);

  const scrollToBottom = () => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  // Google Places Autocomplete
  useEffect(() => {
    if (!adresseInputRef.current) return;
    if (!window.google?.maps?.places) return;

    const ac = new window.google.maps.places.Autocomplete(
      adresseInputRef.current,
      { types: ["address"], componentRestrictions: { country: "fr" } }
    );

    ac.addListener("place_changed", () => {
      const place = ac.getPlace();
      const formatted = place?.formatted_address || "";
      const ok = !!place?.address_components?.length;

      setAdresseDepart(formatted);
      setAdresseDepartPlaceOk(ok);
    });
  }, []);

  const goDevis = () => {
    if (adresseDepart.trim() !== "" && !adresseDepartPlaceOk) {
      alert("Veuillez sélectionner une adresse valide dans la liste Google.");
      return;
    }

    navigate("/devis", {
      state: { adresseDepart: adresseDepart.trim() || null },
    });
  };

  const onKeyDownAdresse = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      goDevis();
    }
  };

  return (
    <div
      className="w-full min-h-screen bg-cover bg-center bg-no-repeat relative overflow-x-hidden"
      style={{ backgroundImage: 'url("/imagefond.png")' }}
    >
      {/* NAVBAR */}
      <nav className="bg-blue-600 text-white px-4 sm:px-6 py-4 relative z-50">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row lg:justify-between lg:items-center gap-4">
          {/* LOGO */}
          <div className="flex justify-center lg:justify-start items-center">
            <img
              src="/Logo.svg"
              alt="Logo"
              className="h-14 sm:h-20 lg:h-24 w-auto max-w-[220px] sm:max-w-[300px] lg:max-w-[380px] object-contain block"
            />
          </div>

          {/* MENU */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 lg:gap-6">
            <button
              className="w-full sm:w-auto px-4 py-2 bg-blue-700/60 rounded-full text-base sm:text-lg lg:text-[20px] hover:bg-white/30 transition"
              onClick={() => navigate("/")}
            >
              Accueil
            </button>

            <button
              className="w-full sm:w-auto px-4 py-2 bg-blue-700/60 rounded-full text-base sm:text-lg lg:text-[20px] hover:bg-white/30 transition"
              onClick={() => navigate("/devis")}
            >
              Devis
            </button>

            <button
              className="w-full sm:w-auto px-4 py-2 bg-blue-700/60 rounded-full text-base sm:text-lg lg:text-[20px] hover:bg-white/30 transition"
              onClick={scrollToBottom}
            >
              Avis
            </button>
          </div>

          {/* CONTACT */}
          <div className="flex flex-col items-center lg:items-end">
            <button className="bg-red-500 px-4 py-2 rounded-md font-bold text-white text-sm sm:text-base">
              07 66 11 91 93
            </button>
            <span className="mt-1 text-xs sm:text-sm">Assistant client</span>
          </div>
        </div>
      </nav>

      {/* HERO */}
      <section className="min-h-[calc(100vh-120px)] flex items-center justify-center px-4 sm:px-6">
        <div className="w-full max-w-5xl text-center">
          <p className="text-white font-semibold text-lg sm:text-xl lg:text-2xl drop-shadow-md">
            Devis gratuit réponse en moins de 5 minutes chrono !
          </p>

          <div className="mt-5 bg-white/95 backdrop-blur-sm shadow-md rounded-3xl sm:rounded-full p-3 sm:p-2 w-full max-w-3xl mx-auto">
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-2 items-stretch">
              <input
                ref={adresseInputRef}
                type="text"
                placeholder="Adresse de départ"
                className="flex-1 px-4 py-3 outline-none rounded-2xl sm:rounded-l-full sm:rounded-r-none text-sm sm:text-base placeholder:text-sm sm:placeholder:text-base"
                onKeyDown={onKeyDownAdresse}
                value={adresseDepart}
                onChange={(e) => {
                  setAdresseDepart(e.target.value);
                  setAdresseDepartPlaceOk(false);
                }}
              />

              <button
                onClick={goDevis}
                className="bg-blue-600 text-white px-5 sm:px-6 py-3 sm:py-4 rounded-2xl sm:rounded-full font-medium text-sm sm:text-base whitespace-nowrap hover:bg-blue-700 transition"
              >
                Devis gratuit
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* AVIS */}
      <section className="bg-gray-100 px-4 sm:px-6 py-10 sm:py-14">
        <div className="w-full max-w-7xl mx-auto">
          <h2 className="text-xl sm:text-2xl font-bold text-center mb-6 text-gray-800">
            Votre avis
          </h2>

          <textarea
            className="w-full h-[220px] sm:h-[260px] lg:h-[300px] p-4 sm:p-6 border border-gray-300 rounded-lg shadow-sm text-gray-700 text-sm sm:text-base lg:text-lg resize-none"
            placeholder="Laisse nous un avis !"
          />

          <div className="flex justify-center sm:justify-end">
            <button className="mt-4 px-6 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition text-sm sm:text-base">
              Envoyer
            </button>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-blue-600 text-white py-6">
        <div
          ref={bottomRef}
          className="max-w-7xl mx-auto px-4 sm:px-6 flex flex-col md:flex-row items-center md:items-start justify-between gap-6 text-center md:text-left"
        >
          {/* LOGO */}
          <div className="flex justify-center md:justify-start">
            <img
              src="/Logo.svg"
              alt="Logo"
              className="h-20 sm:h-24 lg:h-[120px] w-auto object-contain"
            />
          </div>

          <div>
            <p className="font-medium text-sm sm:text-base">
              Agence de déménagement
            </p>
            <p className="text-sm sm:text-base">Dans toute l&apos;Île-de-France !</p>
          </div>

          <div className="text-center md:text-right">
            <p className="font-medium text-sm sm:text-base">Nos coordonnées</p>
            <p className="text-sm sm:text-base">07 66 11 91 93</p>
            <p className="text-sm sm:text-base">contact@demenagerfact.com</p>
            <p className="text-sm sm:text-base">7/7, 8h00 à 20h00</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default HomePage;